import { IBaseFormValues, FormFieldDto, KeyValueDto } from '../types';
import { MILEAGE_FIELD_KEYS, OTHER_FIELD_KEYS, TAXI_FIELD_KEYS, BASE_FORM_VALUE_KEYS, TRAVEL_GUARANTEE_TYPE } from '../constants';

const buildTravelInfoText = (FormData: IBaseFormValues, messageBody: string): string => {
    const { routeNumber, route, hasTransfer, transfer } = FormData;

    const mainTravelInfo = [
        '*** PLANLAGT KOLLEKTIVREISE',
        `Ruternr.: ${routeNumber}`,
        `Reise fra: ${route.placeFrom}`,
        `Reise til: ${route.placeTo || ''}`,
        `Tidspunkt iht. rutetabell: ${route.departureTime}`,
        `Faktisk avgangstid: ${route.actualDepartureTime ?? 'Ikke oppgitt'}`
    ].join('\n\n');

    const transferInfo = hasTransfer
        ? [
              'Inkluderte din planlagte reise overgang til annet Kolumbus-transportmiddel: Ja',
              `Ruternr.: ${transfer.routeNumber}`,
              `Overgangssted: ${transfer.placeFrom}`,
              `Tidspunkt iht. rutetabell: ${transfer.departureTime}`,
              `Faktisk tidspunkt: ${transfer.actualDepartureTime}`
          ].join('\n\n')
        : 'Inkluderte din planlagte reise overgang til annet Kolumbus-transportmiddel: Nei';

    return `${mainTravelInfo}\n\n${transferInfo}\n\nMelding: ${messageBody}`;
};

const buildTransportFormFields = (
    formValues: IBaseFormValues,
    type: string
): { formFieldData: FormFieldDto[]; formAttachments: (File & { content: number[] })[] } => {
    let formFieldData: FormFieldDto[] = [];
    let formAttachments: (File & { content: number[] })[] = [];

    switch (type) {
        case TRAVEL_GUARANTEE_TYPE.TAXI:
            formFieldData = [
                { key: TAXI_FIELD_KEYS.TAXI_OPERATIONAL_NR, value: formValues.taxi.taxiOperationalNr },
                { key: TAXI_FIELD_KEYS.TAXI_TRIP_NR, value: formValues.taxi.taxiTripNr },
                { key: TAXI_FIELD_KEYS.TAXI_RECEIPT_NR, value: formValues.taxi.taxiReceiptNr },
                {
                    key: TAXI_FIELD_KEYS.TAXI_REFUND_AMOUNT,
                    value: formValues.taxi.taxiRefundAmount,
                    type: BASE_FORM_VALUE_KEYS.SYSTEM_INT32
                },
                { key: TAXI_FIELD_KEYS.TAXI_DRIVE_FROM, value: formValues.taxi.taxiDriveFrom },
                { key: TAXI_FIELD_KEYS.TAXI_DRIVE_TO, value: formValues.taxi.taxiDriveTo }
            ];
            formAttachments = formValues.taxi.attachments || [];
            break;
        case TRAVEL_GUARANTEE_TYPE.MILEAGE:
            formFieldData = [
                { key: MILEAGE_FIELD_KEYS.MILEAGE_DRIVE_FROM, value: formValues.mileage.driveFrom },
                { key: MILEAGE_FIELD_KEYS.MILEAGE_DRIVE_TO, value: formValues.mileage.driveTo },
                {
                    key: MILEAGE_FIELD_KEYS.MILEAGE_DISTANCE,
                    value: formValues.mileage.distance,
                    type: BASE_FORM_VALUE_KEYS.SYSTEM_INT32
                },
                { key: MILEAGE_FIELD_KEYS.MILEAGE_VEHICLE_REG_NR, value: formValues.mileage.registrationNo }
            ];
            break;
        case TRAVEL_GUARANTEE_TYPE.OTHER:
            formFieldData = [
                { key: OTHER_FIELD_KEYS.OTHER_TRANSPORT_TYPE, value: formValues.other.transportType },
                { key: OTHER_FIELD_KEYS.OTHER_DRIVE_FROM, value: formValues.other.driveFrom },
                { key: OTHER_FIELD_KEYS.OTHER_DRIVE_TO, value: formValues.other.driveTo },
                {
                    key: OTHER_FIELD_KEYS.OTHER_REFUND_AMOUNT,
                    value: formValues.other.refundAmount,
                    type: BASE_FORM_VALUE_KEYS.SYSTEM_INT32
                }
            ];
            formAttachments = formValues.other.attachments || [];
            break;
        default:
            break;
    }

    return { formFieldData, formAttachments };
};

const getIssueSubCategories = (issueSubCategories: KeyValueDto[]): string[] => issueSubCategories.map(category => category.key);

export { buildTravelInfoText, buildTransportFormFields, getIssueSubCategories };
